import { WithdrawalStatus } from "@redotech/crdb-enums/returns/withdrawal-status";
import * as z from "zod";

export const withdrawalStatusSchema = z.enum(WithdrawalStatus);

export type WithdrawalStatusValue = z.infer<typeof withdrawalStatusSchema>;

const withdrawalTimelineEventSchema = z.object({
  id: z.string(),
  withdrawalId: z.string(),
  message: z.string(),
  createdAt: z.date(),
  isSystem: z.boolean(),
  actorUserId: z.string().nullable(),
});

export const getWithdrawalById = {
  name: "getWithdrawalById" as const,
  input: z.object({ withdrawalId: z.string() }),
  output: z.object({
    withdrawalId: z.string(),
    orderId: z.string(),
    /** The order's display name (e.g. "#2114"), when available. */
    orderName: z.string().nullable(),
    status: withdrawalStatusSchema,
    /** Set once the withdrawal has been turned into a return. */
    returnId: z.string().nullable(),
    orderCompletelyUnfulfilled: z.boolean(),
    /**
     * True when the customer should be warned that items may still ship and may
     * need to be returned after the withdrawal is submitted.
     */
    shouldShowReturnShippingWarning: z.boolean(),
    /** Merchant-customized notice text for the return shipping warning. When absent, the portal uses its default wording. */
    lateWithdrawalNoticeText: z.string().optional(),
    createdAt: z.date(),
    completedAt: z.date().nullable(),
    timeline: z.array(withdrawalTimelineEventSchema),
  }),
};

// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { WithdrawalStatus } from "@redotech/crdb-enums/returns/withdrawal-status";
